"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ArgumentError = void 0;
class ArgumentError extends Error {
    constructor(msg) {
        super(msg ? `ArgumentError: ${msg}` : "ArgumentError");
    }
}
exports.ArgumentError = ArgumentError;
//# sourceMappingURL=ArgumentError.js.map